'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import DefaultModal from 'Modals/DefaultModal';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Select from 'Components/Forms/Elements/Select';
import AdminBookingRow from 'Components/Lists/Rows/AdminBooking';
import BookingRow from 'Components/Lists/Rows/Booking';
import Dashboard from 'Components/Lists/Dashboard';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import handleChange from 'Components/Forms/Functions/handleChange';
import BookingCommentModal from 'Modals/BookingCommentModal';
import DirectBookingForm from 'Components/Forms/Models/Booking/DirectBookingForm';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
import { coworking_place_types, dashboards_status } from 'Shared/options';
const {
  app,
  moment,
  qwest
} = window;
const header = [{
  name: 'created_at',
  label: 'Résa',
  sortable: true
}, {
  name: 'date',
  label: 'Conso',
  sortable: true
}, {
  name: 'coworking_space.name',
  label: 'Espace',
  sortable: true
}, {
  name: 'coworking_space.type',
  label: 'Type',
  sortable: false
}, {
  name: 'number_of_people',
  label: 'Nb de p.',
  sortable: false
}, {
  name: 'customer.lastname',
  label: 'Nom & tel. client',
  sortable: false
}, {
  name: 'amount',
  label: 'CA TTC',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}, {
  name: 'source',
  label: 'Provenance',
  sortable: false
}, {
  name: 'comment',
  label: 'Commentaire',
  sortable: false
}, {
  name: 'PDF',
  label: 'PDF',
  sortable: false
}, {
  name: 'actions',
  sortable: false
}];
const admin_header = [{
  name: 'coworking_space._etablishment.name',
  label: 'Nom de l\'hôtel',
  sortable: false
}, {
  name: 'created_at',
  label: 'Résa',
  sortable: true
}, {
  name: 'date',
  label: 'Conso',
  sortable: true
}, {
  name: 'coworking_space.type',
  label: 'Type',
  sortable: false
}, {
  name: 'customer.lastname',
  label: 'Nom & tel. client',
  sortable: false
}, {
  name: 'amount_ht',
  label: 'CA HT',
  sortable: false
}, {
  name: 'amount_ttc',
  label: 'CA TTC',
  sortable: false
}, {
  name: 'source',
  label: 'Provenance',
  sortable: false
}, {
  name: 'status',
  label: 'Statut',
  sortable: false
}, {
  name: 'PDF',
  label: '',
  sortable: false
}];

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
const customer_type_options = [{
  value: "all",
  label: "Tous les types de client"
}, {
  value: "without_account",
  label: "Sans compte"
}, {
  value: "with_account",
  label: "Avec compte"
}, {
  value: "with_account_and_subscription",
  label: "Avec compte et abonnement"
}];
const newsletter_options = [{
  value: "all",
  label: "Tous"
}, {
  value: "in",
  label: "Opt-in"
}, {
  value: "out",
  label: "Opt-out"
}];
const space_type_options = [{
  value: 'all',
  label: 'Tous'
}].concat(coworking_place_types.map(infos => ({
  value: infos.value,
  label: infos.front_short_label
})));
export default class ExportBtoCMarketingDashboardPage extends Component {
  state = {
    status_messages: {},
    select_key: uniqid(),
    etablishment_filter: 'all',
    customer_type: 'all',
    newsletter: 'all',
    space_type: 'all',
    status: 'all',
    etablishment_options: [{
      value: 'all',
      label: 'Tous les établissements'
    }],
    super_admin_page: document.location.pathname.startsWith('/super-admin/'),
    comment_modal: {},
    openDirectBookingModal: false
  };
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    handleChange.bind(this)({
      e,
      value: value,
      name
    });
    if (value && name === 'created_start_date') {
      component.setState({
        created_end_date: moment(value).add(1, 'day').format('YYYY-MM-DD')
      });
    } else if (value && name === 'start_date') {
      component.setState({
        end_date: moment(value).add(1, 'day').format('YYYY-MM-DD')
      });
    }
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchAllEtablishments();
  }
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent on mount trigger
    if (!e && fields_without_timeout.includes(name) === false) return;
    component.setState({
      [name]: value
    });
    if (fields_without_timeout.includes(name)) return;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    }, 320);
  };
  fetchAllEtablishments = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllEtablishments'), {
      order: "asc",
      order_by: "name"
    }).then(function (xhr, response) {
      let etablishment_options = (response.data || []).map(function (etablishment) {
        const option = {
          value: etablishment.id,
          label: etablishment.name
        };
        return option;
      });
      etablishment_options.unshift({
        value: "all",
        label: "Tous les établissements"
      });
      component.setState({
        etablishments: response.data,
        etablishment_options: etablishment_options,
        select_key: uniqid(),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  openCommentModal = (e, booking) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      comment_modal: {
        open: true,
        booking: booking,
        trg: e?.target
      }
    });
  };
  closeCommentModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      comment_modal: {}
    });
  };
  rows_props = {
    openCommentModal: this.openCommentModal
  };
  openDirectBookingModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDirectBookingModal: true
    });
  };
  closeDirectBookingModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDirectBookingModal: false
    });
  };
  handleCreatedBooking = () => {
    app.emit({
      event: 'RefreshBookingsDashboard'
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const can__export = isTrue(app.state.session?.user?.can_export_data);
    const is__admin = app.state.session?.user?.roles?.includes?.('admin');
    const is__hotel = app.state.session?.user?.roles?.includes?.('hotelier');
    let filters = {
      created_start_date: state.created_start_date,
      created_end_date: state.created_end_date,
      start_date: state.start_date,
      end_date: state.end_date,
      etablishment_id: state.etablishment_filter,
      newsletter: state.newsletter,
      customer_type: state.customer_type,
      space_type: state.space_type,
      b2c_payment_status: state.status,
      b2c: true,
      access_all: state.super_admin_page ? false : is__admin
    };
    if (state.super_admin_page) delete filters.etablishment_id;
    const create_booking_btn = is__hotel || is__admin ? /*#__PURE__*/React.createElement(Button, {
      onClick: component.openDirectBookingModal,
      className: bemit('c-flat-btn', ['primary'])
    }, "Cr\xE9er une r\xE9servation") : undefined;
    const used_header = is__admin && !state.super_admin_page ? admin_header : header;
    const fields = header.map(infos => infos.name);
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "R\xE9servations"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dashboard-right u-full-width u-flex\r u-content-between"
    }, create_booking_btn, isTrue(can__export) ? /*#__PURE__*/React.createElement("div", {
      className: "u-flex u-margin-left-10 u-flex-gap-20"
    }, /*#__PURE__*/React.createElement(Button, {
      href: "/export/marketing-commande-b2c?start_date=" + (state.start_date || "") + '&end_date=' + (state.end_date || "") + '&created_start_date=' + (state.created_start_date || "") + '&created_end_date=' + (state.created_end_date || "") + '&etablishment_filter=' + (state.etablishment_filter || "") + '&customer_type=' + (state.customer_type || "") + '&newsletter=' + (state.newsletter || "") + '&space_type=' + (state.space_type || "") + '&payment_status=' + (state.status || ""),
      className: bemit('c-flat-btn', ['primary']),
      target: "_blank",
      component: Link
    }, "Exporter les r\xE9servations"), /*#__PURE__*/React.createElement(Button, {
      href: "/export/marketing-clients-b2c?start_date=" + (state.start_date || "") + '&end_date=' + (state.end_date || "") + '&created_start_date=' + (state.created_start_date || "") + '&created_end_date=' + (state.created_end_date || "") + '&etablishment_filter=' + (state.etablishment_filter || "") + '&customer_type=' + (state.customer_type || "") + '&newsletter=' + (state.newsletter || "") + '&space_type=' + (state.space_type || "") + '&payment_status=' + (state.status || ""),
      className: bemit('c-flat-btn', ['primary']),
      target: "_blank",
      component: Link
    }, "Exporter les clients"), is__admin ? /*#__PURE__*/React.createElement(Button, {
      target: "_blank",
      rel: "noreferrer",
      href: action('ExportPurchasedServices'),
      className: bemit('c-flat-btn', ['primary']),
      style: {
        alignSelf: 'stretch'
      }
    }, "Export des services consomm\xE9s") : undefined) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--bookings"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['created_start_date'] || "",
      className: "cutom-date-picker",
      name: "created_start_date",
      label: "Date de commande (d\xE9but)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['created_end_date'] || "",
      className: "cutom-date-picker",
      name: "created_end_date",
      label: "Date de commande (fin)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de consommation (d\xE9but)",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de consommation (fin)",
      "allow-no-value": true,
      status: state.status_messages
    })), is__admin && !state.super_admin_page ? /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: state.etablishment_options,
      defaultValue: state.etablishment_options[0]?.value,
      onChange: component.handleChange,
      key: state.select_key,
      value: state['etablishment_filter'],
      name: "etablishment_filter",
      type: "text",
      label: "Etablissement",
      status: state.status_messages
    })) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: customer_type_options,
      defaultValue: customer_type_options[0]?.value,
      onChange: component.handleChange,
      value: state['customer_type'],
      name: "customer_type",
      type: "text",
      label: "Type de client",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: newsletter_options,
      defaultValue: newsletter_options[0]?.value,
      onChange: component.handleChange,
      value: state['newsletter'],
      name: "newsletter",
      type: "text",
      label: "Opt-in/Opt-out",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: space_type_options,
      defaultValue: space_type_options[0]?.value,
      onChange: component.handleChange,
      value: state['space_type'],
      name: "space_type",
      type: "text",
      label: "Type de prestation",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(Select, {
      options: dashboards_status,
      defaultValue: dashboards_status[0]?.value,
      onChange: component.handleChange,
      value: state['status'],
      name: "status",
      type: "text",
      label: "Statut",
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-paper u-padding-top-0\r no-horizontal-padding"
    }, /*#__PURE__*/React.createElement(Dashboard, {
      model: "Booking",
      url: action('getAllBookings'),
      header: used_header,
      fields: fields,
      component: is__admin && !state.super_admin_page ? AdminBookingRow : BookingRow,
      "items-per-page": 30,
      filters: filters,
      "row-props": component.rows_props,
      "request-update": "RefreshBookingsDashboard"
    })))), /*#__PURE__*/React.createElement(BookingCommentModal, {
      open: state.comment_modal?.open,
      trg: state.comment_modal?.trg,
      onClose: component.closeCommentModal,
      booking: state.comment_modal?.booking
    }), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.openDirectBookingModal,
      title: "R\xE9servation directe",
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeDirectBookingModal
    }, /*#__PURE__*/React.createElement(DirectBookingForm, {
      fromModal: true,
      closeDirectBookingModal: component.closeDirectBookingModal,
      onValidated: component.handleCreatedBooking
    })));
    return output;
  }
}
